import Reveal from "./Reveal";

const SLOGANS = [
  "RESTART PRO — to je nový začátek.",
  "Nestavíme jen domy. Tvoříme prostor pro život.",
  "Každý projekt je příběh. Váš příběh.",
  "Nestavíme jen dům. Budujeme pocit domova.",
  "Nestavíme jen budovy. Budujeme budoucnost.",
  "Dům není adresa. Je to místo, kam se vracíte.",
];

export default function Philosophy() {
  return (
    <section
      id="filozofie"
      data-testid="philosophy-section"
      className="py-24 lg:py-36 bg-ink relative overflow-hidden"
    >
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-gold/5 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative">
        <Reveal>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-gold/70 mb-4">
            Naše filozofie
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-6xl text-zinc-100 leading-tight max-w-3xl">
            Stavíme to, na co jste <span className="gold-text">šetřili celý život</span>
          </h2>
          <p className="mt-7 max-w-2xl text-zinc-400 leading-relaxed text-base sm:text-lg">
            Dobře víme, co to znamená stavět dům nebo rekonstruovat byt. Znamená to vzít si
            velkou půjčku, zadlužit se na léta dopředu, nebo do toho vložit celoživotní úspory —
            a s nimi veškeré úsilí a sny. K vaší stavbě proto přistupujeme s obrovským
            respektem: stavíme ji s takovou péčí, jako bychom stavěli pro sebe. Známe normy, ale
            díky praxi také víme, kdy existuje mnohem chytřejší a praktičtější řešení.
          </p>
        </Reveal>

        <div className="mt-16 lg:mt-20 border-t border-white/5">
          {SLOGANS.map((s, i) => (
            <Reveal key={i} delay={0.05}>
              <div
                data-testid={`philosophy-slogan-${i}`}
                className={`group flex items-baseline gap-5 sm:gap-8 py-6 sm:py-7 border-b border-white/5 ${
                  i % 2 ? "flex-row-reverse text-right" : ""
                }`}
              >
                <span className="font-mono text-xs text-gold/40 shrink-0">0{i + 1}</span>
                <p className="font-display text-xl sm:text-2xl lg:text-3xl text-zinc-300 group-hover:text-gold-light transition-colors duration-500 leading-snug">
                  {s}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p
            className="mt-16 lg:mt-20 text-center font-display text-4xl sm:text-5xl lg:text-6xl gold-text"
            data-testid="philosophy-final"
          >
            Komfort. Klid. Jistota.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
